import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PageShell from "../components/PageShell";
import Logo from "../components/Logo";

export default function NotFoundPage() {
  return (
    <PageShell>
      <section
        data-testid="not-found"
        className="min-h-[80vh] grid place-items-center px-6 pt-28 pb-20"
      >
        <div className="max-w-xl w-full text-center">
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: [0, -8, 6, -4, 0] }}
            transition={{ duration: 1.4, ease: "easeOut", repeat: Infinity, repeatDelay: 4 }}
            className="mx-auto mb-8"
          >
            <Logo variant="mark" className="h-24 w-auto text-primary-x" />
          </motion.div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-muted-x font-mono-x">
            ◇ 404 · NOT FOUND
          </div>
          <h1 className="mt-4 font-display text-6xl md:text-8xl font-bold tracking-[-0.045em] leading-[0.9] text-primary-x">
            Nothing here<br />
            <em className="not-italic text-muted-x">but us.</em>
          </h1>
          <p className="mt-8 text-secondary-x leading-relaxed">
            The page you&apos;re looking for either moved, never existed, or is hiding from us as much as it&apos;s hiding from you.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="not-found-home"
              className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium hover:opacity-90 transition-opacity"
              style={{ background: "var(--text-primary)", color: "var(--canvas)" }}
            >
              Take me home →
            </Link>
            <Link
              to="/work"
              className="inline-flex items-center gap-2 rounded-full border border-hairline-strong px-5 py-2.5 text-sm text-primary-x hover-glass transition-colors"
            >
              See our work →
            </Link>
          </div>
          <p className="mt-12 text-xs text-muted-x font-mono-x tracking-[0.18em] uppercase">
            tip · press <kbd className="border border-hairline-strong rounded px-1.5 py-0.5 mx-1">?</kbd> anywhere for shortcuts
          </p>
        </div>
      </section>
    </PageShell>
  );
}
